import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';
import {
  MiddlewareAPI,
  isRejectedWithValue,
  Middleware,
} from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { returnEndPointKey } from './apiEndPointNames';
import baseApiUrl from './baseApiUrl';

// All requests that use this endpoint will extend from it by injecting endPoints

// need to handle providing the correct API route
// winndow.location.hostname should work fine fo testing

// may need some logic here to properly set the baseUrl for all requests

export const api = createApi({
  reducerPath: 'api',

  baseQuery: fetchBaseQuery({
    // all requests will use this url unless we have other baseURL required
    baseUrl: baseApiUrl,
    prepareHeaders: (headers, { getState }) => {
      // set the authorization header on every request it is available
      // maybe check the token here??? for the refresh token
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('Authorization', `${token}`);
      }
      return headers;
    },
    timeout: 600000, // 10 Minutes is way to long to wait
  }),
  tagTypes: [
    'Users',
    'UserPreferences',
    'Chains',
    'Sites',
    'SiteUsers',
    'SiteControllerBackups',
    'Applications',
    'Floorplans',
    'FloorplanMarkers',
    'AlarmReceivers',
    'AlarmFilters',
    'UnregisteredLeos',
    'UnknownLeos',
    'LeoAlertSchedule',
    'UsingAdvAlertSchedule',
    'AdvAlertSchedules',
    'AdvAlertScheduleEvents',
    'AdvAlertScheduleReceivers',
    'RefrigerantSystems',
    'RefrigerantUnassignedSystems',
    'UnassignedManualSystems',
    'RefrigerantSystemsCombinedAudits',
    'RefrigerantSystemsAuditWindow',
    'RefrigerantAuditFiles',
    'Maintenance',
  ],
  endpoints: () => ({}),
});

/**
 * Log a warning and show a toast! Doesn't seem to be working currently.
 */
export const rtkQueryErrorLogger: Middleware =
  (_api: MiddlewareAPI) => (next) => (action) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these use matchers!
    if (isRejectedWithValue(action)) {
      console.warn('We got a rejected action!');
      console.info({ action });

      // @ts-expect-error this exists
      const endPointName = action?.meta?.arg?.endpointName as string;
      // @ts-expect-error this exists
      const type = action?.meta?.arg?.type;
      // @ts-expect-error this exists
      const status = action?.payload?.status;
      // @ts-expect-error this exists
      const message = action?.payload?.data?.message;

      if (
        status &&
        status === 401 &&
        message &&
        (message?.toLowerCase() === 'invalid token' ||
          message?.toLowerCase() === 'signature expired')
      ) {
        console.info(
          '%clogging out because 401 response (the server said the token is invalid)',
          'color: orange',
        );
        _api.dispatch({
          payload: true,
          type: 'view/showSessionExpiredDialog',
        });
        _api.dispatch({ type: 'auth/logout' });
        _api.dispatch({ type: 'sites/resetHiddenChains' });
      } else if (
        status &&
        status === 403 &&
        message?.toLowerCase() === 'unauthorized access to store'
      ) {
        enqueueSnackbar({
          message: 'Unauthorized access to site',
          variant: 'error',
          SnackbarProps: { title: 'Error' },
          preventDuplicate: true,
        });
        _api.dispatch({
          payload: undefined,
          type: 'view/handleShowUnauthorizedSiteAccess',
        });
      } else {
        // type: "mutation" is handled within the components
        if (type === 'query') {
          const message = `Failed to fetch ${returnEndPointKey(endPointName)}`;
          // @ts-expect-error this exists
          const title = `${action.payload.status} Error`;
          console.info('Creating SnackBar!!!');
          console.info({ title, message });
          enqueueSnackbar({
            message,
            variant: 'error',
            SnackbarProps: { title: title },
            preventDuplicate: true,
          });
        }
      }
    }

    return next(action);
  };
